import { push } from 'connected-react-router'
import { connect } from 'react-redux'
import { compose, lifecycle } from 'recompose'
import { bindActionCreators } from 'redux'

import { authenticateWithCode, getAccessToken } from '@driftt/web-auth'

import config from 'config'
import LoadingPage from 'layouts/LoadingPage'
import * as UserActions from 'modules/user/actions'
import {
  hasSubmittedOnboardingSurvey,
  isExtensionInstalled,
} from 'utils/extension'
import { resolveParam } from 'utils/routing'

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      fetchUser: UserActions.fetchUser,
      push,
    },
    dispatch
  ),
})

export default compose(
  connect(null, mapDispatchToProps),
  lifecycle({
    async componentDidMount() {
      // HANDLES REDIRECTING THE USER IMMEDIATELY AFTER SIGNING IN WITH GOOGLE OR MICROSOFT
      const authorizationCode = resolveParam('code')
      await authenticateWithCode({
        authorizationCode,
        clientId: config.CLIENT_ID,
      })

      if (getAccessToken()) {
        this.props.actions.fetchUser()
      }

      const hasExtension = await isExtensionInstalled()
      let nextState = '/video/landing'

      // whether this was a brand new account or signing in, next step is the survey if you haven't done so already
      if (!hasSubmittedOnboardingSurvey) {
        nextState = '/video/survey'

        // if you already did that, maybe install the extension
      } else if (!hasExtension) {
        nextState = '/video/extension'

        // otherwise, send along to the router page and we'll get you into the video app
      }

      this.props.actions.push(nextState)
    },
  })
)(LoadingPage)
